export default __webpack_public_path__ + "static/media/add-customers.a431dd68.svg";